export const Send = ({ width = 16, height = 16, color = '#2E2E2E' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_10656)">
        <path
          d="M15.5422 7.27609L1.94217 0.876095C1.80524 0.811307 1.65271 0.786772 1.50237 0.805349C1.35203 0.823925 1.21006 0.884848 1.09301 0.981016C0.975969 1.07718 0.888666 1.20464 0.84128 1.34852C0.793894 1.49241 0.788377 1.6468 0.825373 1.79369L2.37657 8.00009L0.825373 14.2065C0.788031 14.3534 0.793307 14.508 0.840582 14.6521C0.887858 14.7961 0.975178 14.9237 1.09233 15.02C1.20948 15.1163 1.35162 15.1772 1.50212 15.1956C1.65262 15.214 1.80525 15.1892 1.94217 15.1241L15.5422 8.72409C15.6796 8.65949 15.7958 8.5571 15.8772 8.42889C15.9586 8.30069 16.0018 8.15196 16.0018 8.00009C16.0018 7.84823 15.9586 7.6995 15.8772 7.5713C15.7958 7.44309 15.6796 7.3407 15.5422 7.27609ZM2.78617 12.9577L3.45737 10.2721L8.00137 8.00009L3.45737 5.72809L2.78617 3.04249L13.3222 8.00009L2.78617 12.9577Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19_10656">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
